import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';

export const useIsSpeechToTextEnabled = (isVoiceDictationEnabled: boolean): boolean => {
	if (!isVoiceDictationEnabled) {
		return false;
	}

	return (
		expVal('ai_speech_to_text', 'isEnabled', false) ||
		expVal('ai_speech_to_text_holdout_ineligible', 'isEnabled', false)
	);
};
